import React, {createRef} from "react";

import Context from "../../../../context/Context";
import FieldNames from "../../../../aiim/datasets/FieldNames";
import {ModalController} from "../../../../common/components/Modal";
import OfficePlan from "../../../base/OfficePlan";
import Topic from "../../../../context/Topic";
import TransactionGuard from "../../../base/TransactionGuard";
import * as aiimUtil from "../../../../aiim/util/aiimUtil";
import * as component from "../../../../components/util/component";
import * as sourceUtil from "../../../base/sourceUtil";
import * as transactions from "../../../base/transaction/transactions";
import * as tsUtil from "../../../../util/tsUtil";

export default class AttributeEditor extends React.Component {

  _coreNodeRef = createRef();
  _coreWidget;

  constructor(props) {
    super(props);
    this.state = component.newState({});
  }

  componentDidMount () {
    this._initWidget();
  }

  componentWillUnmount() {
    component.componentWillUnmount(this);
  }

  _initWidget() {
    const context = Context.instance;
    const node = this._coreNodeRef && this._coreNodeRef.current;
    if (node) {
      this._coreWidget = new context.lib.indoors.CustomFeatureForm({
        indoorsContext: context,
        tsUtil: tsUtil,
        container: node,
        feature: this.props.feature,
        indoorsOptions: this.props.options
      });
      if (this.props.onCreateForm) {
        this.props.onCreateForm(this,this._coreWidget);
      }
    }
  }

  render() {
    return (
      <div>
        <div ref={this._coreNodeRef}></div>
      </div>
    );
  }

  static show(options) {
    let attributes = options.feature.attributes;

    if (options.type === "unit") {
      if (!options.layer) {
        options.layer = sourceUtil.getUnitsLayer();
      }
      if (!options.title) {
        options.title = aiimUtil.getAttributeValue(attributes,FieldNames.NAME);
      }
    } else if (options.type === "person") {
      if (!options.layer) {
        options.layer = sourceUtil.getPeopleLayer();
      }
      if (!options.title) {
        options.title = aiimUtil.getAttributeValue(attributes,FieldNames.PEOPLE_FULLNAME);
      }
    }
    let feature = new Context.instance.lib.esri.Graphic({
      attributes: attributes
    })
    feature.layer = options.layer;

    // options.layer.fields.forEach(f => {
    //   //if (f.name === "NAME_LONG") f.nullable = false;
    //   console.log(f.name,f.nullable,f)
    // })

    let controller, okButton, featureForm;
    let trackChange = true;

    const applyEdit = edit => {
      const guard = new TransactionGuard({force: true});
      Promise.resolve().then(() => {
        return transactions.updateAttributes(options.type,options.feature,edit.attributes);
      }).then(() => {
        guard.close();
        Topic.publish(Topic.PlanModified, {
          action: OfficePlan.Action_AssignmentsUpdated,
        });
      }).catch((error) => {
        guard.close();
        console.error("Error updating feature", error);
        Topic.publishErrorUpdatingData(error.submessage);
      });
    };

    const tooLong = (inputField) => {
      const length = inputField.field && inputField.field.length;
      return length && inputField.value && inputField.value.length > length;
    }

    const hasValidChanges = () => {
      let changed = false;
      if (featureForm) {
        const inputs = featureForm.viewModel._allInputFields;
        const useTypeInput = inputs.find((input) => input.name.toLowerCase() === "use_type");
        if (useTypeInput) {
          useTypeInput.domain = useTypeInput.field.domain;
        }
        const hasInvalid = inputs.some(inputField => {
          return (!inputField.valid || tooLong(inputField));
        });
        if (!hasInvalid) {
          const updated = featureForm.getValues();
          Object.keys(updated).some(name => {
            if (attributes[name] !== updated[name]) {
              changed = true;
            }
            return changed;
          });
        }
      }
      return changed;
    }

    let content = (
      <div className="i-modal-attribute-editor">
        <AttributeEditor feature={feature} options={options}
          onCreateForm={(ae,ff) => {
            featureForm = ff;

            if (trackChange) {
              featureForm.on("value-change",info => {
                if (okButton) {
                  if (hasValidChanges()) {
                    okButton.enable();
                  } else {
                    okButton.disable();
                  }
                }
              });
            }

            featureForm.on("submit",info => {
              if (info.invalid && info.invalid.length > 0) {
                // TODO ???
                return;
              }
              let changed = false;
              const edit = {attributes: {}}
              const updated = featureForm.getValues();
              Object.keys(updated).forEach(name => {
                if (attributes[name] !== updated[name]) {
                  changed = true;
                  edit.attributes[name] = updated[name];
                }
              });
              controller.close();
              if (changed) {
                applyEdit(edit);
              }
            });

          }}
        />
      </div>
    );

    const modalProps = {
      dialogStyle: {minHeight: "35vh", minWidth: "35vw"},
      title: options.title,
      noPadding: true,
      okLabel: Context.instance.i18n.general.update,
      showOKCancel: true,
      closeOnOK: false,
      onMountOKButton: btn => {
        okButton = btn;
        if (trackChange) okButton.disable()
      },
      onOK: () => {
        if (okButton && featureForm) {
          okButton.disable();
          featureForm.submit();
        }
      },
    };

    controller = new ModalController({});
    controller.show(modalProps, content);
  }

}
